import * as types from './types'


export function setStatus(statusName, statusValue) {
    return {
      type: types.SET_STATUS,
      statusName,
      statusValue
    }
  }